export type { QueryErrorFallbackProps } from './QueryErrorBoundary';
export { QueryErrorBoundary } from './QueryErrorBoundary';
export { useSuspenseQuery } from './useSuspenseQuery';
